/* istanbul ignore file */
export default {
  namespaced: true,
	state: {
    wfInfo: null
	},
	getters: {
		isOpen(state) {
		  return !!state.wfInfo
		},
	},
	mutations: {
		closeModal(state) {
			state.wfInfo = null;
		},
    openModal(state, obj) {
      state.wfInfo = obj;
    },
	},
}
